import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import storageName from '../constant';
var isClient = typeof window !== 'undefined';

var WebStorageUtility = function WebStorageUtility() {
  var _this = this;

  _classCallCheck(this, WebStorageUtility);

  this.isLocalStorageEnabled = false;
  this.isSessionStorageEnabled = false;
  this.isCookieEnabled = false;

  this.isLocalStorageServiceEnabled = function () {
    try {
      localStorage.setItem('storageData', storageName);
      localStorage.removeItem('storageData');
      return true;
    } catch (e) {
      return false;
    }
  };

  this.isSessionStorageServiceEnabled = function () {
    try {
      sessionStorage.setItem('storageData', storageName);
      sessionStorage.removeItem('storageData');
      return true;
    } catch (e) {
      return false;
    }
  };

  this.isCookieServiceEnabled = function () {
    var _navigator = navigator,
        cookieEnabled = _navigator.cookieEnabled;

    if (cookieEnabled) {
      return true;
    }

    try {
      document.cookie = "".concat(storageName, ";");
      return document.cookie.indexOf(storageName) !== -1;
    } catch (e) {
      return false;
    }
  };

  this.setDecrypted = function (value) {
    return typeof value === 'string' && value !== 'undefined' ? value : _JSON$stringify(value);
  };

  this.setEncryped = function (value) {
    return typeof value === 'string' && value !== 'undefined' ? btoa(value) : btoa(_JSON$stringify(value));
  };

  this.getSettable = function (value) {
    var encrypt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (encrypt) return _this.setEncryped(value);
    return _this.setDecrypted(value);
  };

  this.getServerGettable = function (value) {
    var decrypt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    try {
      var buff = Buffer.from(value, 'base64');
      return decrypt ? JSON.parse(buff.toString('ascii')) : JSON.parse(value);
    } catch (e) {
      var _buff = Buffer.from(value, 'base64');

      return decrypt ? _buff.toString('ascii') : value;
    }
  };

  this.getClientGettable = function (value) {
    var decrypt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    try {
      return decrypt ? JSON.parse(atob(value)) : JSON.parse(value);
    } catch (e) {
      return decrypt ? atob(value) : value;
    }
  };

  this.getGettable = function (value, decrypt) {
    return isClient ? _this.getClientGettable(value, decrypt) : _this.getServerGettable(value, decrypt);
  };

  this.isLocalStorageEnabled = isClient && this.isLocalStorageServiceEnabled();
  this.isSessionStorageEnabled = isClient && this.isSessionStorageServiceEnabled();
  this.isCookieEnabled = isClient && this.isCookieServiceEnabled();
}
/**
 * @private
 * Checks whether local storage service is available
 */
;

var webStorageUtility = new WebStorageUtility();
export default webStorageUtility;